import { useEffect, useState } from "react";
import { find } from "lodash";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Alert from "../../../components/Alert";
import Table from "../../../components/Table";
import Edit from "../../../assets/svgs/edit.svg";
import Delete from "../../../assets/svgs/delete.svg";
import NewInvoice from "../../../assets/svgs/receipt.svg";
import DeleteItem from "../../../components/DeleteItem";
import { Actions } from "../../../internals/app/Actions";
import AddCustomer from "../../../components/AddCustomer";
import CustomerHeader from "../../../components/CustomerHeader";
import StatementDialog from "../../invoice/components/StatementDialog";
import { useSelectedShop } from "../../invoice/useInvoicing";

// No statement icon in assets/svgs: a document-with-lines glyph in the row icons' grey.
const StatementIcon = `data:image/svg+xml;utf8,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16"><path d="M2 0h7l5 5v9.5A1.5 1.5 0 0 1 12.5 16h-10A1.5 1.5 0 0 1 1 14.5v-13A1.5 1.5 0 0 1 2.5 0Zm6.5 1.2V5.5h4.3ZM3.5 8a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1Zm0 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1Zm0 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1Z" fill="#a5a6c3" fill-rule="evenodd"/></svg>'
)}`;

const tableHeader = [
  "CLIENT NAME",
  "CLIENT EMAIL",
  "PHONE NUMBER",
  "APPOINTMENTS	",
  "ACTIONS",
];

const actionLabels = ["Edit", "Delete", "New invoice", "Statement"];

const CustomerView = (props: any) => {
  const { alertStatus, openAlertBox, clientList, deleteClient } = props;
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [tableData, setTableData] = useState<Array<any>>([]);
  const [isOpenDelete, setIsOpenDelete] = useState<boolean>(false);
  const [statementFor, setStatementFor] = useState<any>(null);
  const selectedShop = useSelectedShop();

  useEffect(() => {
    if (clientList.clients) {
      const tableData = getData(clientList.clients);
      setTableData(tableData);
    }
  }, [clientList]);

  const getData = (data: any) => {
    return data.map((item: any) => {
      return {
        id: item.id,
        APPOINTMENTS: "",
        ACTIONS: [Edit, Delete, NewInvoice, StatementIcon],
        "CLIENT EMAIL": item.email,
        "CLIENT NAME": `${item.firstName} ${item.lastName}`,
        "PHONE NUMBER": item.mobileNumber.length > 7 ? item.mobileNumber : "",
      };
    });
  };

  const onClickItem = (data: any, index: number) => {
    if (index === 2) {
      navigate(`/invoices/new?clientId=${encodeURIComponent(data.id)}`);
      return;
    }
    if (index === 3) {
      setStatementFor(find(clientList.clients, (item) => item.id === data.id) ?? null);
      return;
    }
    const client = find(clientList.clients, (item) => item.id === data.id);
    setCustomer(client);
    if (index === 0) {
      toggleCustomer();
    } else if (index === 1) {
      toggleDelete();
    }
  };

  const toggleDelete = () => {
    setIsOpenDelete(!isOpenDelete);
  };

  const toggleCustomer = () => {
    setIsOpen(!isOpen);
  };

  const onDeleteClient = (data: any) => {
    deleteClient(data.id, data.shopId);
    toggleDelete();
  };

  return (
    <div className="flex flex-col w-full p-6 justify-start">
      <Alert
        alertStatus={alertStatus}
        onCloseAlert={(status: any) =>
          openAlertBox(status, false, alertStatus.successStatus)
        }
      />
      <div className="pb-6">
        <CustomerHeader
          openCustomer={() => {
            setCustomer(null);
            toggleCustomer();
          }}
        />
      </div>
      <Table
        {...{ tableHeader, tableData, actionLabels }}
        onClickItem={onClickItem}
      />
      <AddCustomer
        isOpen={isOpen}
        customer={customer}
        closeModal={() => toggleCustomer()}
      />
      <DeleteItem
        isOpen={isOpenDelete}
        closeModal={() => toggleDelete()}
        onDelete={() => onDeleteClient(customer)}
      />
      <StatementDialog
        open={!!statementFor && !!selectedShop?.shopId}
        onClose={() => setStatementFor(null)}
        shopId={selectedShop?.shopId}
        clientId={statementFor?.id}
        customerName={`${statementFor?.firstName ?? ""} ${statementFor?.lastName ?? ""}`.trim()}
        phone={statementFor?.mobileNumber}
        email={statementFor?.email}
      />
    </div>
  );
};

export default connect(
  (state: any) => ({
    alertStatus: state.common.get("alertStatus"),
    clientList: state.customer.get("clientList"),
  }),
  {
    openAlertBox: Actions.common.openAlertBox,
    deleteClient: Actions.customer.deleteClient,
  }
)(CustomerView);
